module.exports = __webpack_public_path__ + "static/media/mycenaean_text_03.b04b6a15.jpg";